var render = function render(_c, _vm) {
  return _c(
    "div",
    { staticClass: "row roomy size-sm margin-top-6xl", attrs: { id: "faqs" } },
    [
      _c("article", { staticClass: "column-12 laptop:column-6" }, [
        _c(
          "div",
          {
            staticClass: "message with-icon",
            staticStyle: {
              "--message-background": "none",
              "--message-with-icon-decorative-color": "var(--fa-navy)",
              "--message-border-width": "0",
              "margin-left": "calc(var(--message-horizontal-padding) * -1)",
              "--message-with-icon-decorative-scale": "2",
            },
          },
          [
            _c("font-awesome-icon", {
              staticClass: "decorative",
              attrs: { icon: _vm.parent.$v6.regular.faPartyHorn },
            }),
            _vm._v(" "),
            _c("h4", { staticClass: "title" }, [
              _vm._v("Sponsorship Shout Out!"),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "You'll be noted as an official sponsor when folks view your commissioned icon's details and we'll sing about your support on fontawesome.com."
              ),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("article", { staticClass: "column-12 laptop:column-6" }, [
        _c(
          "div",
          {
            staticClass: "message with-icon",
            staticStyle: {
              "--message-background": "none",
              "--message-with-icon-decorative-color": "var(--fa-navy)",
              "--message-border-width": "0",
              "margin-left": "calc(var(--message-horizontal-padding) * -1)",
              "--message-with-icon-decorative-scale": "2",
            },
          },
          [
            _c("font-awesome-icon", {
              staticClass: "decorative",
              attrs: { icon: _vm.parent.$v6.regular.faHandshake },
            }),
            _vm._v(" "),
            _c("h4", { staticClass: "title" }, [_vm._v("We'll Work with You")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        We'll work with you to take your original request as inspiration as we design. You'll be able to check out the direction during the icon design\n        process and before we ship things officially.\n      "
              ),
            ]),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }